import React, { useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

import { formatPrice } from "../../helpers/formatPrice";

import { Glyphicon } from "../Glyphicon/Glyphicon";

import {
  ArticleRow,
  Thumbnail,
  AttributeContainer,
  AttributeText,
  DiscountedPrice,
  OrdinaryPrice,
  ExpandTd,
  ThumbnailTd,
  QuantityTd,
  PriceContainer,
  ExpandedAttributes,
  ShowMore,
} from "./style";

export const ArticleItem = ({ article }) => {
  const [showAttributes, setShowAttributes] = useState(false);
  const [imageError, setImageError] = useState(false);

  const init = useSelector((state) => state.init);
  const { currency, assetBaseUrl, articleImageBaseUrl, alias } = init;

  function expandArticleInfo() {
    setShowAttributes(!showAttributes);
  }

  if (!article.Sku) {
    console.error("Missing Sku on article:", article);
    return;
  }

  return (
    <>
      <ArticleRow data-id={`ArticleRow_${article.Sku}`}>
        {/* If article has additional attributes/information, show expand sign*/}
        {article.Attributes.length > 0 ? (
          <ExpandTd
            onClick={() => expandArticleInfo()}
            data-id={`ExpandTd_${article.Sku}`}
          >
            <Glyphicon name={showAttributes ? "minus" : "plus"} />
          </ExpandTd>
        ) : (
          <ExpandTd />
        )}
        <ThumbnailTd>
          <Thumbnail
            src={
              imageError
                ? `${assetBaseUrl}/store/layout/imagemissing/imagemissing.gif`
                : `${articleImageBaseUrl}/cguide/${article.Sku}?d=144x144`
            }
            onError={() => setImageError(true)}
          />
        </ThumbnailTd>
        <td>{article.Title}</td>
        <td>
          <span className="show-on-mobile">{alias.bfcArtNr}:</span>
          {article.Sku}
        </td>
        <QuantityTd>
          <span className="show-on-mobile">{alias.bfcAmount}:</span>
          {article.Quantity}
        </QuantityTd>
        <td>
          {article.Price === article.OrdinaryPrice ? (
            <span>{formatPrice(article.OrdinaryPrice, currency)}</span>
          ) : (
            <PriceContainer>
              <DiscountedPrice>
                {formatPrice(article.Price, currency)}
              </DiscountedPrice>
              <OrdinaryPrice>
                {formatPrice(article.OrdinaryPrice, currency)}
              </OrdinaryPrice>
            </PriceContainer>
          )}
        </td>
        {article.Attributes.length > 0 && (
          <ShowMore onClick={() => expandArticleInfo()}>
            {alias.bfcShowSpecs}{" "}
            <Glyphicon name={showAttributes ? "minus" : "plus"} />
          </ShowMore>
        )}
      </ArticleRow>
      {showAttributes && (
        <ExpandedAttributes>
          <td colSpan="6">
            {article.Attributes.map((attribute) => (
              <AttributeContainer key={attribute.Value}>
                <AttributeText>{attribute.Title}</AttributeText>
                <AttributeText>{attribute.Value}</AttributeText>
              </AttributeContainer>
            ))}
          </td>
        </ExpandedAttributes>
      )}
    </>

  );
};

ArticleItem.propTypes = {
  article: PropTypes.object,
};
